import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const InfoField = ({
  title,
  children,
  isEditing,
  onFieldChange,
  canEdit,
  hasChanges
}) => {
  // Detectar si children es JSX o texto simple
  const isJSX = React.isValidElement(children);
  const isMinusIcon =
    (isJSX && children.props?.className?.includes('fas fa-minus')) ||
    (typeof children === 'string' && children === 'fas fa-minus');

  // Solo usar localValue para texto simple
  const [localValue, setLocalValue] = useState(
    typeof children === 'string' ? children : ''
  );

  // Sincronizar localValue con children cuando cambie (solo para texto)
  useEffect(() => {
    if (typeof children === 'string') {
      setLocalValue(children);
    }
  }, [children]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    if (isEditing && canEdit) {
      setLocalValue(newValue);
      onFieldChange(newValue);
    }
  };

  return (
    <div className={`info-field ${hasChanges ? 'field-modified' : ''}`}>
      <div>
        <div>
          <strong>{title}:</strong>
          {hasChanges && (
            <span
              className="badge badge-info ms-2"
              style={{ fontSize: '0.7rem' }}>
              Modified
            </span>
          )}
        </div>
      </div>
      <div style={{ marginTop: '14px' }}>
        {isEditing && canEdit ? (
          <>
            <input
              type="text"
              value={localValue}
              onChange={handleInputChange}
              className={`form-control ${hasChanges ? 'border-warning' : ''}`}
              placeholder={isMinusIcon ? 'Enter description...' : ''}
            />
          </>
        ) : (
          <div>
            {isJSX ? (
              // Renderizar JSX directamente
              children
            ) : localValue && localValue !== '' ? (
              <span>{localValue}</span>
            ) : (
              <i className="fas fa-minus"></i>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

InfoField.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node,
  isEditing: PropTypes.bool,
  onFieldChange: PropTypes.func,
  canEdit: PropTypes.bool,
  hasChanges: PropTypes.bool
};

InfoField.defaultProps = {
  isEditing: false,
  canEdit: true,
  hasChanges: false
};

export default InfoField;
